import { render, staticRenderFns } from "./ImportantDateBanner.vue?vue&type=template&id=76aea1ff&scoped=true"
import script from "./ImportantDateBanner.vue?vue&type=script&lang=ts"
export * from "./ImportantDateBanner.vue?vue&type=script&lang=ts"
import style0 from "./ImportantDateBanner.vue?vue&type=style&index=0&id=76aea1ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aea1ff",
  null
  
)

export default component.exports